class AriaLink extends HTMLElement {
    constructor() {
        super();

        this.setAttribute('role', 'link');
        this.setAttribute('tabindex', '0');

        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeyDown);
    }

    open() {
        const url = this.getAttribute('href');
        const target = this.getAttribute('target');
        const features = this.getAttribute('rel')
            ?.split(' ')
            .filter(Boolean)
            .join(',');

        window.open(url, target, features);
    }

    onClick() {
        this.open();
    }

    /**
     * @param {KeyboardEvent} event
     */
    onKeyDown(event) {
        if (event.key === 'Enter') {
            this.open();
        }
    }
}

customElements.define('aria-link', AriaLink);
export default AriaLink;
